import React from "react";
import { Link } from "react-router-dom";
import { InlineMath } from "react-katex";

const CBSEChemistry10 = () => {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px", fontFamily: "'Nunito', 'Poppins', sans-serif", lineHeight: "1.8", color: "#1e293b" }}>
      
      <div style={{ background: "linear-gradient(135deg, #1e3a5f, #2c5282)", borderRadius: 16, padding: "40px 30px", color: "white", marginBottom: 30, textAlign: "center" }}>
        <h1 style={{ fontSize: "32px", margin: "0 0 10px 0" }}>🧪 CBSE Class 10 Chemistry — Complete Guide</h1>
        <p style={{ fontSize: "18px", opacity: 0.9, margin: "0 0 20px 0" }}>Chemical Reactions, Acids & Bases, Metals & Non-Metals, Carbon Compounds — master them all with instant AI help.</p>
        <a href="https://wa.me/919731453435?text=Help%20me%20with%20Class%2010%20Chemistry" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "14px 32px", background: "#25D366", color: "white", borderRadius: 50, textDecoration: "none", fontWeight: "bold", fontSize: "16px" }}>
          💬 Ask Eluvent on WhatsApp
        </a>
      </div>

      <div style={{ background: "#f1f5f9", borderRadius: 12, padding: "20px", marginBottom: 30 }}>
        <h2 style={{ margin: "0 0 12px 0", fontSize: "20px" }}>📑 Jump to Chapter</h2>
        <ul style={{ columns: 2, paddingLeft: 20, margin: 0 }}>
          <li><a href="#reactions" style={{ color: "#2c5282" }}>Chemical Reactions & Equations</a></li>
          <li><a href="#acids" style={{ color: "#2c5282" }}>Acids, Bases & Salts</a></li>
          <li><a href="#metals" style={{ color: "#2c5282" }}>Metals & Non-Metals</a></li>
          <li><a href="#carbon" style={{ color: "#2c5282" }}>Carbon and its Compounds</a></li>
          <li><a href="#periodic" style={{ color: "#2c5282" }}>Periodic Classification</a></li>
        </ul>
      </div>

      <div id="reactions" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #e07b39", paddingLeft: 12, fontSize: "24px" }}>1. Chemical Reactions & Equations</h2>
        <p>Chemical reactions involve the transformation of reactants into products. They follow the Law of Conservation of Mass.</p>
        
        <h3>🔑 Types of Reactions</h3>
        <ul>
          <li><strong>Combination:</strong> <InlineMath math="A + B \rightarrow AB" /> (e.g., <InlineMath math="CaO + H_2O \rightarrow Ca(OH)_2" />)</li>
          <li><strong>Decomposition:</strong> <InlineMath math="AB \rightarrow A + B" /> (e.g., <InlineMath math="CaCO_3 \xrightarrow{\Delta} CaO + CO_2" />)</li>
          <li><strong>Displacement:</strong> <InlineMath math="A + BC \rightarrow AC + B" /> (e.g., <InlineMath math="Fe + CuSO_4 \rightarrow FeSO_4 + Cu" />)</li>
          <li><strong>Double Displacement:</strong> <InlineMath math="AB + CD \rightarrow AD + CB" /></li>
          <li><strong>Redox:</strong> Involves both oxidation and reduction</li>
        </ul>

        <a href="https://wa.me/919731453435?text=Explain%20chemical%20reactions%20and%20equations%20class%2010" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 How to balance equations? Ask Eluvent →
        </a>
      </div>

      <div id="acids" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #e07b39", paddingLeft: 12, fontSize: "24px" }}>2. Acids, Bases & Salts</h2>
        <p>Acids taste sour (like lemon), bases taste bitter (like soap). Their strength is measured on the pH scale (0-14).</p>
        
        <h3>🔑 Key Concepts</h3>
        <ul>
          <li><strong>pH Scale:</strong> Below 7 = Acid, 7 = Neutral, Above 7 = Base</li>
          <li><strong>Indicators:</strong> Litmus, Phenolphthalein, Methyl Orange, Turmeric</li>
          <li><strong>Neutralization:</strong> <InlineMath math="Acid + Base \rightarrow Salt + Water" /></li>
          <li><strong>Common Salts:</strong> NaCl (Table Salt), NaHCO₃ (Baking Soda), CaOCl₂ (Bleaching Powder)</li>
        </ul>

        <a href="https://wa.me/919731453435?text=Explain%20acids%20bases%20and%20salts%20class%2010" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 pH Scale confusing? Ask Eluvent →
        </a>
      </div>

      <div id="metals" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #e07b39", paddingLeft: 12, fontSize: "24px" }}>3. Metals & Non-Metals</h2>
        <p>Metals are lustrous, malleable, ductile, and good conductors. Non-metals are generally brittle and poor conductors.</p>
        
        <h3>🔑 Key Differences</h3>
        <ul>
          <li><strong>Reaction with Oxygen:</strong> Metals form basic oxides; Non-metals form acidic oxides</li>
          <li><strong>Reaction with Water:</strong> Na, K react vigorously; Fe rusts slowly</li>
          <li><strong>Reactivity Series:</strong> K {'>'} Na {'>'} Ca {'>'} Mg {'>'} Al {'>'} Zn {'>'} Fe {'>'} Pb {'>'} H {'>'} Cu {'>'} Hg {'>'} Ag {'>'} Au</li>
          <li><strong>Aqua Regia:</strong> 3:1 mixture of HCl and HNO₃ — dissolves gold and platinum</li>
        </ul>

        <a href="https://wa.me/919731453435?text=Explain%20metals%20and%20non%20metals%20class%2010" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 Reactivity series trick? Ask Eluvent →
        </a>
      </div>

      <div id="carbon" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #e07b39", paddingLeft: 12, fontSize: "24px" }}>4. Carbon and its Compounds</h2>
        <p>Carbon forms covalent bonds and can create long chains (catenation), making it the backbone of organic chemistry.</p>
        
        <h3>🔑 Key Concepts</h3>
        <ul>
          <li><strong>Allotropes:</strong> Diamond, Graphite, Fullerene</li>
          <li><strong>Hydrocarbons:</strong> Alkanes (C-C single bond), Alkenes (C=C double bond), Alkynes (C≡C triple bond)</li>
          <li><strong>Functional Groups:</strong> Alcohol (-OH), Aldehyde (-CHO), Ketone (-CO-), Carboxylic Acid (-COOH)</li>
          <li><strong>Soaps & Detergents:</strong> Micelle formation cleans dirt</li>
        </ul>

        <a href="https://wa.me/919731453435?text=Explain%20carbon%20and%20its%20compounds%20class%2010" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 Functional groups? Ask Eluvent →
        </a>
      </div>

      <div id="periodic" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #e07b39", paddingLeft: 12, fontSize: "24px" }}>5. Periodic Classification of Elements</h2>
        <p>Elements are arranged in the periodic table based on increasing atomic number. Modern periodic table has 18 groups and 7 periods.</p>
        
        <h3>🔑 Key Trends</h3>
        <ul>
          <li><strong>Atomic Size:</strong> Decreases across a period, increases down a group</li>
          <li><strong>Metallic Character:</strong> Decreases across a period, increases down a group</li>
          <li><strong>Electronegativity:</strong> Increases across a period, decreases down a group</li>
        </ul>

        <a href="https://wa.me/919731453435?text=Explain%20periodic%20classification%20class%2010" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 Periodic trends? Ask Eluvent →
        </a>
      </div>

      {/* FAQ */}
      <div style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #e07b39", paddingLeft: 12, fontSize: "24px" }}>❓ Frequently Asked Questions</h2>
        
        <div itemScope itemType="https://schema.org/FAQPage">
          <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question" style={{ marginBottom: 16, padding: "16px", background: "#f8fafc", borderRadius: 8 }}>
            <h3 itemProp="name" style={{ fontSize: "16px", margin: "0 0 8px 0" }}>Q: How to balance chemical equations easily?</h3>
            <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
              <p itemProp="text" style={{ margin: 0 }}>Start by balancing the most complex molecule first. Count atoms on both sides. Use trial and error — or ask Eluvent to balance any equation instantly on WhatsApp!</p>
            </div>
          </div>

          <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question" style={{ marginBottom: 16, padding: "16px", background: "#f8fafc", borderRadius: 8 }}>
            <h3 itemProp="name" style={{ fontSize: "16px", margin: "0 0 8px 0" }}>Q: What is the most scoring chapter in Class 10 Chemistry?</h3>
            <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
              <p itemProp="text" style={{ margin: 0 }}>Carbon and its Compounds and Chemical Reactions are high-weightage chapters. Master these and you're set for a strong score.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Interlinking */}
      <div style={{ background: "#e0f2fe", borderRadius: 12, padding: "20px", marginBottom: 30, textAlign: "center" }}>
        <h3 style={{ margin: "0 0 12px 0" }}>📚 Explore Other Subjects</h3>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
          <Link to="/cbse-class-10-physics" style={{ padding: "10px 18px", background: "#2c5282", color: "white", borderRadius: 20, textDecoration: "none", fontSize: "14px" }}>⚡ Physics</Link>
          <Link to="/cbse-class-10-maths" style={{ padding: "10px 18px", background: "#2c5282", color: "white", borderRadius: 20, textDecoration: "none", fontSize: "14px" }}>📐 Mathematics</Link>
          <Link to="/cbse-class-10-biology" style={{ padding: "10px 18px", background: "#2c5282", color: "white", borderRadius: 20, textDecoration: "none", fontSize: "14px" }}>🧬 Biology</Link>
        </div>
      </div>

      <div style={{ textAlign: "center", padding: "30px", background: "linear-gradient(135deg, #1e3a5f, #2c5282)", borderRadius: 16, color: "white" }}>
        <h2 style={{ margin: "0 0 10px 0" }}>🚀 Ready to Ace Chemistry?</h2>
        <p style={{ margin: "0 0 20px 0", fontSize: "16px" }}>Ask any question on WhatsApp and get instant, clear answers from Eluvent.</p>
        <a href="https://wa.me/919731453435?text=Help%20me%20with%20CBSE%20Class%2010%20Chemistry" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "14px 32px", background: "#25D366", color: "white", borderRadius: 50, textDecoration: "none", fontWeight: "bold", fontSize: "16px" }}>
          💬 Start Learning on WhatsApp
        </a>
      </div>

    </div>
  );
};

export default CBSEChemistry10;